export class VideoCallStadisticsModel {
  attentionDate: string = ''; // Formato: "DD/MM/YYYY"
  conferenceId: number; // ID de la conferencia
  medicId: string = ''; // ID del médico
  medicName: string = ''; // Nombre del médico
  medicEnteredAt: string = ''; // Fecha y hora de entrada del médico
  medicBrowser: string = ''; // Navegador del médico
  medicDevice: string = ''; // Dispositivo del médico
  patientDNI: string = ''; // DNI del paciente
  patientEnteredAt: string = ''; // Fecha y hora de entrada del paciente
  patientBrowser: string = ''; // Navegador del paciente
  patientDevice: string = ''; // Dispositivo del paciente
  medicFinalizedAt: string = ''; // Fecha y hora de finalización del médico
  patientFinalizedAt: string = ''; // Fecha y hora de finalización del paciente
  totalDuration: string = ''; // Duración total de la videoconferencia
  reconnectionMedic: string = ''; // Información sobre reconexiones del médico
  reconnectionPatient: string = ''; // Información sobre reconexiones del paciente
  origen: string = ''; // Origen de la videoconferencia
  uuid: string; // Identificador único de la sesión
  streamfinished: string = '';
  reasondisconnectionmedic: string = '';
  reasondisconnectionpatient: string = '';
}
